import React from "react";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";
import "../../i18next";
import nosotros from "../../assets/images/Nosotros/nosotros1.jpeg";
import AnimatedElement from "../AnimatedElement";

function SectionBgImage() {
  const { t, i18n } = useTranslation();
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  const textVariants = {
    hidden: { opacity: 0, y: -50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  const textFromBottomVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  return (
    <section className="relative  py-10" ref={ref}>
      {/* Contenedor responsive */}
      <div className="flex flex-col lg:flex-row items-start gap-8 px-5 md:px-12">
        {/* Columna de títulos */}
        <div className="w-full lg:w-1/2 space-y-4">
          <div
            fromDirection="top"
            style={{ fontFamily: "Helvetica" }}
            className="text-3xl sm:text-4xl md:text-6xl lg:text-8xl font-bold text-orangeAtm"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={textVariants}
          >
            {t("aboutUs.innovation")}
          </div>

          <AnimatedElement
            fromDirection="top"
            style={{ fontFamily: "Helvetica" }}
            className="text-3xl sm:text-4xl md:text-6xl lg:text-8xl font-bold text-blue-700"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={textVariants}
          >
            {t("aboutUs.security")}
          </AnimatedElement>

          <AnimatedElement
            fromDirection="top"
            style={{ fontFamily: "Helvetica" }}
            className="text-3xl sm:text-4xl md:text-6xl lg:text-8xl font-bold text-blue-700 z-10"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={textVariants}
          >
            {t("aboutUs.development")}
          </AnimatedElement>
        </div>

        {/* Columna de texto */}
        <AnimatedElement
          fromDirection="top"
          style={{ fontFamily: "Helvetica" }}
          className="w-full lg:w-1/2 text-xl text-[#0A3343] "
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={textFromBottomVariants}
        >
          <p>{t("aboutUs.text1")}</p>
        </AnimatedElement>
      </div>

      {/* Imagen inferior */}
      <AnimatedElement
        fromDirection="bottom"
        className="mt-10"
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        variants={textFromBottomVariants}
      >
        <img
          src={nosotros}
          alt="Nosotros"
          className="object-contain w-full h-auto max-w-full mx-auto"
        />
      </AnimatedElement>
    </section>
  );
}

export default SectionBgImage;
